import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  loadError: {
    id: 'screens.MissionControl.Utilities.NewFormBuilderPage.loadError',
    defaultMessage: 'Something went wrong.',
  },
  newView: {
    id: 'screens.nexty-next.ScheduleView.scheduleLaunch.newView',
    defaultMessage:
      'Welcome to our new Schedule view! Learn more about this new layout in our <a target="_blank" href="https://support.lumahealth.io/hc/en-us/articles/22820073948059-A-New-Schedule-for-a-More-Intuitive-Experience" rel="noreferrer">Help Center</a>, and be sure to let us know how you like this updated feature!',
  },
  oldView: {
    id: 'screens.nexty-next.ScheduleView.scheduleLaunch.oldView',
    defaultMessage: 'A new Schedule experience is here. Check it out now!',
  },
});
